module.exports = __webpack_public_path__ + "media/images/samples/1280x768/4-7c994337e64f23180a683850bcce53a3.jpg";